import { SearchParams } from '@src/types/typesense';
import { buildFilterBy } from '@src/utils/typesense';
import { useHits, useInstantSearch } from 'react-instantsearch';

export const useParams = () => {
  const { results } = useHits();
  const { uiState } = useInstantSearch();

  // console.log('results -> ', results);

  const params: SearchParams = {
    query: results.query ?? '*',
    hitsPerPage: results.hitsPerPage ?? 12,
    page: results.page ?? 0,
    sortBy: 'series:asc,paper:asc,question_number:asc',
    filter_by: buildFilterBy(uiState['questions']?.refinementList ?? {}),
    totalHits: results.nbHits ?? 0,
  };

  return {
    params,
    hits: results.hits,
    nbPages: results.nbPages ?? 1,
  };
};
